import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Checkbox, Col, Label, Row } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import { required } from '../../../utils/utils';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
};

function CheckboxFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
}) {
  const { locale } = useIntl();
  const {
    label,
    type,
    isRequired,
    canEdit,
    defaultValue,
    isRepeatable,
    helpeText,
    name,
  } = fieldValues;

  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  const handleFieldLabelAppeerance = () => {
    if (isRepeatable || (parentField?.type === 'fieldArray' && index !== 0)) {
      return null;
    }

    return <Label fullWidth>{fieldLabel}</Label>;
  };

  return (
    <Row>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <Field
          id={`inventory-templates-form-generator-${type}-field-${index}`}
          label={handleFieldLabelAppeerance()}
          name={fieldName}
          component={Checkbox}
          subscription={{ value: true }}
          type="checkbox"
          required={isRequired}
          validate={isRequired ? required : undefined}
          disabled={!canEdit}
          defaultValue={defaultValue === 'true'}
          format={(v) => v === true}
          inline={parentField?.type === 'fieldArray'}
          vertical={parentField?.type === 'fieldArray'}
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.helpeIcon}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

CheckboxFieldComponent.propTypes = propTypes;

export default CheckboxFieldComponent;
